import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React from 'react';
import PropTypes from 'prop-types';
import { a as addClassNames, c as classNameProps } from './classNames-6a4763fd.js';
import { a as addSpacingClasses, m as marginProps } from './spacing-d13ff368.js';

function Checkbox(_ref) {
  let {
    className,
    margin,
    error,
    disabled
  } = _ref,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "margin", "error", "disabled"]);

  let cssClasses = ['st_checkbox'];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin,
    cssClasses
  });
  const inputProps = {};

  if (error) {
    cssClasses.push('st_checkbox--invalid');
  }

  if (disabled) {
    inputProps.disabled = disabled;
    cssClasses.push('st_checkbox--disabled');
  }

  return /*#__PURE__*/React.createElement("input", _extends({
    className: cssClasses.join(' '),
    type: "checkbox"
  }, inputProps, otherProps));
}

Checkbox.propTypes = {
  /** extra CSS classes, if any */
  className: classNameProps,

  /** margin for box, if any */
  margin: marginProps,

  /** whether input is invalid, e.g. error state */
  error: PropTypes.bool,

  /** whether input is disabled */
  disabled: PropTypes.bool
};
Checkbox.defaultProps = {
  className: null,
  margin: null,
  error: false,
  disabled: false
};

export default Checkbox;
